import React, { useEffect } from "react";

import {
  Heading,
  P,
  SectionHeading,
  SectionSmallHeading,
  SectionSubHeading,
  SectionWrapper,
} from "../../../styles";
import styled from "@emotion/styled";
import { Container, Grid, Typography } from "@mui/material"; 

import Aos from "aos";
import "aos/dist/aos.css";
const Background = styled.div`
  background-color: black;
  padding: 59px 0px;
  // background: url("/images/bg.png");
  // background-repeat: no-repeat;
  // background-position: center;
  // background-size: cover;
  // min-height: 100vh;
  // display: flex;
  // align-items: center;
  // @media screen and (max-width: 899px) {
  //   padding: 100px 0 0 0;
  // }
`;

const Intro = styled(Grid)`
  padding: 25px 0px;
  height: 126px;
  display: flex;
  align-items: end;
  background-color: #004f64;
  border: 1px solid black;
  @media screen and (max-width: 899px) {
    // padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
`;
const IntroImage = styled(Grid)`
  padding: 50px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 899px) {
    padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
`;
const Div = styled.div``;

const S8_Ticker = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.addEventListener("load", function () {
      Aos.init();
    });
  }, []);
  return (
    <div>
      <Background>
        <Container maxWidth="xl">
          <Grid container style={{ textAlign: "center" }}>
            <Intro xs={12} md={3} p599="30px 0 0 0" align="center">
              <Div
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                // data-aos-delay="500"
                // data-aos-offset="0"
                data-aos-duration="1500"
                style={{ width: "100%" }}
              >
                <P
                  maxWidth="100%"
                  p="0px 0px 30px 0"
                  style={{
                    justifyContent: "space-between",
                    display: "flex",
                    padding: "0 21px",
                  }}
                >
                  <span>
                    Transtion <br></br> per second
                  </span>
                  <span style={{ fontSize: "25px", fontWeight: "900" }}>
                    100
                  </span>
                </P>
              </Div>
            </Intro>
            <Intro xs={12} md={3} p599="30px 0 0 0" align="center">
              <Div
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                // data-aos-delay="500"
                // data-aos-offset="0"
                data-aos-duration="1500"
                style={{ width: "100%" }}
              >
                <P
                  maxWidth="100%"
                  p="0px 0px 30px 0"
                 
                  style={{
                    justifyContent: "space-between",
                    display: "flex",
                    padding: "0 21px",
                  }}
                >
                  <span>
                    Total <br></br> Transactions
                  </span>
                  <span style={{ fontSize: "25px", fontWeight: "900" }}>
                    2000
                  </span>
                </P>
              </Div>
            </Intro>
            <Intro xs={12} md={3} p599="30px 0 0 0" align="center">
              <Div
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                // data-aos-delay="500"
                // data-aos-offset="0"
                data-aos-duration="1500"
                style={{ width: "100%" }}
              >
                <P
                  maxWidth="100%"
                  p="0px 0px 30px 0"
                 
                  style={{
                    justifyContent: "space-between",
                    display: "flex",
                    padding: "0 21px",
                  }}
                >
                  <span>
                    Avg. Cost Per <br></br> Transactions
                  </span>
                  <span style={{ fontSize: "25px", fontWeight: "900" }}>
                    $0.002
                  </span>
                </P>
              </Div>
            </Intro>
            <Intro xs={12} md={3} p599="30px 0 0 0" align="center">
              <Div
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                // data-aos-delay="500"
                // data-aos-offset="0"
                data-aos-duration="1500"
                style={{ width: "100%" }}
              >
                <P
                  maxWidth="100%"
                  p="0px 0px 30px 0"
                 
                  style={{
                    justifyContent: "space-between",
                    display: "flex",
                    padding: "0 21px",
                  }}
                >
                  <span>
                    Validator <br></br> Transactions
                  </span>
                  <span style={{ fontSize: "25px", fontWeight: "900" }}>
                    10
                  </span>
                </P>
              </Div>
            </Intro>
            {/* <IntroImage
              xs={12}
              md={6}
              data-aos="fade-zoom-in"
              data-aos-easing="ease-in"
              // data-aos-delay="500"
              // data-aos-offset="0"
              data-aos-duration="1500"
            >
              
            </IntroImage> */}
          </Grid>
        </Container>
      </Background>
    </div>
  );
};

export default S8_Ticker;
